import { render, staticRenderFns } from "./MapSvg81.vue?vue&type=template&id=28daaca3"
import script from "./MapSvg81.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapSvg81.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports